import React from 'react';
import { T } from './speedTheme';
import SpeedSiege from './SpeedSiege';

/**
 * **공속 탭** — 점령용 판정 화면 하나뿐이다.
 *
 * 예전에는 프리셋·공속·순서·조율까지 다섯 갈래였는데, 쓰는 건 점령용 하나여서 나머지는
 * 걷어냈다(`SpeedPreset`·`SpeedQuick`·`SpeedCalc`·`SpeedTune` 도 같이 지웠다). 다시 필요하면
 * 지운 커밋에서 꺼내 오면 된다.
 *
 * 여기서는 바탕색만 입히고 셈과 화면은 `SpeedSiege` 가 한다.
 */
export default function SpeedPage({ isMobile, monsterMapping }: { isMobile: boolean; monsterMapping: any }) {
    return (
        <div style={{
            width: '100%',
            minHeight: 'calc(100vh - 60px)',
            background: T.bg,
            color: T.text,
            padding: isMobile ? 'clamp(12px, 3vw, 20px) clamp(6px, 2vw, 12px)' : '24px 20px'
        }}>
            <SpeedSiege isMobile={isMobile} monsterMapping={monsterMapping} />
        </div>
    );
}
